import React from 'react';
import FadeIn from './FadeIn';

const days = [
  {
    day: '7:30 AM',
    time: 'Morning',
    title: 'Welcome Networking Breakfast',
    desc: 'Start the day connecting with Cameroon’s most ambitious professionals over breakfast. Build your first relationships before the summit doors open.',
  },
  {
    day: '8:00 AM',
    time: 'Morning',
    title: 'International Keynote Addresses',
    desc: 'Hear from 10+ national and international speakers setting the tone for what it means to Rise Locally and Lead Globally from Cameroon.',
  },
  {
    day: '9:00 AM',
    time: 'Mid-Morning',
    title: 'Panel: Cameroonian Talent Globally',
    desc: 'Industry leaders explore how Cameroonian professionals are breaking into global markets and what it takes to build a career that transcends borders.',
  },
  {
    day: '11:00 AM',
    time: 'Late Morning',
    title: 'LinkedIn Career Clinic (Live)',
    desc: 'Hands-on live sessions: profile optimisation, personal branding workshops, and direct feedback from LinkedIn experts. Walk out with a stronger digital presence.',
  },
  {
    day: '1:00 PM',
    time: 'Afternoon',
    title: 'Breakout Sessions — 3 Parallel Tracks',
    desc: 'Deep dives across three tracks: Career & Recruitment, Entrepreneurship & SMEs, and Digital Skills & Tech. Choose the path that moves your career forward.',
  },
  {
    day: '4:00 PM',
    time: 'Late Afternoon',
    title: 'Awards Ceremony — 10 Categories',
    desc: 'Celebrating 10 categories of Cameroonian professional excellence. Recognising the individuals and organisations shaping the future of the nation.',
  },
  {
    day: '7:30 PM',
    time: 'Evening',
    title: 'Gala Evening Dinner',
    desc: 'Close the summit in style. A black-tie networking dinner bringing together 2,000 delegates, partners, and speakers for a night of celebration and connection.',
  },
];

function BlueBurst() {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {Array.from({ length: 8 }).map((_, i) => {
        const angle = (i * 45 * Math.PI) / 180;
        const x1 = 50 + 8 * Math.cos(angle);
        const y1 = 50 + 8 * Math.sin(angle);
        const x2 = 50 + 42 * Math.cos(angle);
        const y2 = 50 + 42 * Math.sin(angle);
        return (
          <rect
            key={i}
            x={x1 - 5}
            y={y1 - 5}
            width="10"
            height={Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2)}
            rx="3"
            fill="#2563EB"
            transform={`rotate(${i * 45}, ${(x1 + x2) / 2}, ${(y1 + y2) / 2})`}
            opacity="0.85"
          />
        );
      })}
    </svg>
  );
}

export default function Agenda() {
  return (
    <section className="agenda" id="schedule">
      <div className="container">
        <FadeIn>
        <div className="section-heading-row">
          <h2 className="section-heading-xl">AGENDA</h2>
          <div className="section-sub">
            LLC 2026 | Douala, Cameroon
          </div>
        </div>
        </FadeIn>
        <FadeIn delay={1}>
        <div className="agenda__card">
          {days.map((d, i) => (
            <div className="agenda__item" key={i}>
              <div>
                <div className="agenda__day-label">{d.day}</div>
                <div className="agenda__time">{d.time}</div>
              </div>
              <div>
                <h3 className="agenda__session-title">{d.title}</h3>
                <p className="agenda__session-desc">{d.desc}</p>
                {i === 2 && (
                  <div style={{ marginTop: '28px' }}>
                    <a href="#tickets" className="btn-primary">
                      View detailed schedule ↗
                    </a>
                  </div>
                )}
              </div>
              {i === 2 && (
                <div style={{ position: 'absolute', bottom: '20px', left: '20px', opacity: 0.7 }}>
                  <BlueBurst />
                </div>
              )}
            </div>
          ))}
        </div>
        </FadeIn>
      </div>
    </section>
  );
}
